import { render, staticRenderFns } from "./LoginSignUpForm.vue?vue&type=template&id=4547cac7&scoped=true&"
import script from "./LoginSignUpForm.vue?vue&type=script&lang=ts&"
export * from "./LoginSignUpForm.vue?vue&type=script&lang=ts&"
import style0 from "./LoginSignUpForm.vue?vue&type=style&index=0&id=4547cac7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4547cac7",
  null
  
)

export default component.exports